import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Force the apex host: www.lazonarestorative.com -> lazonarestorative.com
if (typeof window !== "undefined" && window.location.hostname.startsWith("www.")) {
  const { pathname, search, hash } = window.location;
  window.location.replace(`https://lazonarestorative.com${pathname}${search}${hash}`);
} else {
  createRoot(document.getElementById("root")!).render(<App />);
}
